import React, { useState, useEffect, useRef } from 'react';

const FeaturesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const features = [
    {
      id: 1,
      image: '/images/CRESSON-HONEY.webp',
      title: 'Authentic & Pure Mediterranean Honey.',
    },
    {
      id: 2,
      image: '/images/TEAM.webp',
      title: 'Crafted with Traditional Methods',
    },
    {
      id: 3,
      image: '/images/eucalyptus-plant.jpg',
      title: 'A Commitment to Sustainability',
    },
    {
      id: 4,
      image: '/images/oranger-plant.jpg',
      title: 'An Exquisite & Beneficial Experience',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => sectionRef.current && observer.unobserve(sectionRef.current);
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`bg-white py-20 transition-opacity duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 text-center">
        <h2
          className="text-3xl md:text-4xl font-semibold text-[#1a1a1a] mb-6"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Purity, Passion, Exceptional Quality
        </h2>

        <div className="flex flex-wrap justify-center gap-8 sm:gap-16 lg:gap-40 mt-12 sm:mt-16 lg:mt-24">
          {features.map((feature) => (
            <div key={feature.id} className="w-32 sm:w-40 flex flex-col items-center text-center">
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full overflow-hidden shadow-md mb-4">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-sm text-gray-700">{feature.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
